import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { SessionStore } from '../store/session.store';

export const featureGuard: CanActivateFn = (route) => {
	const router = inject(Router);
	const store = inject(SessionStore);

	const requiredFeatures = route.data['features'] as string[] | undefined;

	if (!requiredFeatures || requiredFeatures.length === 0) {
		return true;
	}

	return toObservable(store.status).pipe(
		filter((status) => status !== 'loading'),
		take(1),
		map(() => {
			const hasPermission = store.features().some((feature) => requiredFeatures.includes(feature.slug));

			if (hasPermission) {
				return true;
			}

			return router.createUrlTree(['/network/dashboard']);
		}),
	);
};
